// Cota de geração de roteiro com IA — fonte única da constante.
//
// Importada tanto pelo cliente (aiAccessGate.js, newTripModal.js) quanto pelo
// backend (functions/_lib/auth/requireAiAccess.js). Por isso vive em `src/` e
// é um módulo PURO (sem imports) — o backend já importa de src/features/home/
// (aiImport.js), então o mesmo padrão vale aqui.

// Cota grátis PADRÃO de gerações de roteiro com IA (vitalícia — não renova).
//
// É o FALLBACK: o valor que vale de verdade vem de `appConfig/ai.freeTrips`,
// editável pelo admin. Este número só é usado se esse doc não existir / não
// puder ser lido. Além disso, um usuário pode ter um limite individual em
// `aiAccess/{uid}.aiTripsLimit` que sobrepõe o global.
export const AI_FREE_TRIPS = 2;

// Níveis de "thinking" do Gemini, do mais barato ao mais caro. Cada token de
// raciocínio é cobrado como output, então o nível mexe direto no custo. O
// admin escolhe por usuário (aiAccess/{uid}.thinkingLevel); sem nada setado,
// vale o default global (env GEMINI_THINKING_LEVEL). Ordem = barato → caro.
export const AI_THINKING_LEVELS = ['minimal', 'low', 'medium', 'high'];
